<template>

    <div class="sarea">
        <div class="header">
            <div v-for="(item,index) in address.region" :key='index' @click="onSelect(index)"
                :class="{ 'active': tabsActiveIndex==index }"
            >
                <div>{{item.text}}</div>
            </div>
        </div>
        <div class="citys" ref="cmdlist">
             <div v-for="(item,index) in columns" :key='index' @click="onChange(index)" class="city"
             :class="{ 'active': address.region[tabsActiveIndex].index===index }">
                 {{item.text}}
             </div>   
        </div>

    </div>

 

</template>

<script>


    export default {
        name: 'Sarea',
        data(){
            return {
                tabsActiveIndex:0,

            }
        },
        mounted(){
            // if (!this.address.region) {
            //       this.address.region = [{ text: '请选择', index: -1, value: '' }];
            // }
           
            console.log("mounted")
        },
        created(){
            console.log("created")

            console.log("address ",this.address);
             if (!this.address.region) {
                 this.address.region = [{ text: '请选择', index: -1, value: '' }];
             }
        },
        props: {
            address:{
                type:Array
            }
        },
        methods:{
            onSelect(index) {
                this.tabsActiveIndex = index;
                setTimeout(() => this.scrolltotop(), 120);
            },
            scrolltotop(){
                this.$nextTick(() => {
                        this.$refs.cmdlist.scrollTop = 0;
                 });
            },
             onChange(index) {
               
               if (!this.tabsActiveIndex) {
                         let data = { text: this.address[index].text, value: this.address[index].value }
                         this.address.region[0] = Object.assign({ index: index }, data);
                         if (!this.address[index].child) {
                                this.address.region.splice(1, 1);
                                this.address.text = data.text;
                                this.$emit('areaselected',this.address.region); 
                                return;
                         }
                           this.onSelect(1);
                           this.address.region[1] = { index: -1, text: '请选择', value: '' };
                           this.address.region.splice(2, 1);
                           console.log("xxx ",this.address.region[0]);
                           console.log("xxx ",this.address.region[1]);

                }else if (this.tabsActiveIndex == 1){
                     let data = this.address[this.address.region[0].index].child[index];
                     this.address.region[1] = { index: index, text: data.text, value: data.value }
                     this.address.text = this.address.region[0].text + ' ' + data.text;
                     this.$emit('areaselected',this.address.region);

                }

             }
        },
        computed:{
            columns(){
                  if (!this.tabsActiveIndex) {
                        return this.address;
                  } else if (this.tabsActiveIndex == 1)  {
                        return this.address[this.address.region[0].index].child;
                  }
            } 

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .sarea{
    
    }

    

    .header{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding:0px 0px;
        font-size: 17px;
        div{
                height: 100%;
                display: flex;
                align-items: center;
                padding-left: 10px;
                padding-right: 10px;
                justify-content: center;
        }
        background-color: #FAFAFA;
        position: absolute;
        top:0px;
        height: 50px;
        width: 100%;

        .active{
            color: #ed5b68;
            border-bottom: 1.5px solid #ed5b68;
        }
    }
    .citys{
        position: absolute;
        top:50px;
        bottom: 0px;
        height: 88%;
        width: 100%;
        overflow-y: auto;
    }

     .active{
            color:#ed5b68;
        }


    .city{
        position: relative;
        padding: 15px 10px 15px 20px;
        font-size: 17px;
        font-weight: 0 !important;
        
       
        &::after{
            height: 0.55px;
            content: "";
            bottom: 0px;
            width: 100%;
            background: #dadada !important;
            position: absolute;
            right: 0;
            -webkit-transform: scaleY(0.35);
            -ms-transform: scaleY(0.35);
            transform: scaleY(0.35);
            z-index: 99;
        }
    }

</style>
